import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Paragraph2 } from '@cian/ui-kit';
import * as React from 'react';
import { TitleContainer } from '../../../TitleContainer';
import { RememberedAccountItem } from '../../../../components/RememberedAccountItem';
import { RememberedAccountsLayout } from '../../../../components/RememberedAccountsLayout';
import { ERememberedAccountType } from '../../../../types/rememberedAccounts';
import { EActiveFlow } from '../../../../types/flow';
import { getRememberedAccounts, deleteRememberedAccount } from '../../../../utils/rememberedAccounts';
import { formatPhone } from '../../../../utils/formatPhone';
import { isEmail } from '../../../../utils/validation';
import { changeToPhoneAuth, changeToUsernameAuth, resetToPhoneAuth } from '../../../../actions/state';
import { checkEmail } from '../../../../actions/authentication';
import { changeFlow } from '../../../../actions/flow';
import { trackDeleteRememberedAccount, trackEnterOtherAccount, trackSelectRememberedAccount } from './tracking';
export var RememberedAccountsContainer = function RememberedAccountsContainer(_ref) {
  var useDispatch = _ref.useDispatch;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      accounts = _React$useState2[0],
      setAccounts = _React$useState2[1];

  var dispatch = useDispatch();
  var switchFlow = React.useCallback(function () {
    dispatch(resetToPhoneAuth());
  }, [dispatch]);
  React.useEffect(function () {
    var accounts = getRememberedAccounts();

    if (accounts.length === 0) {
      switchFlow();
    }

    setAccounts(accounts);
  }, []);
  var handleAccountClick = React.useCallback(function (type, value, index) {
    if (type === ERememberedAccountType.Phone) {
      var phone = formatPhone(value);
      dispatch(changeToPhoneAuth(phone));
    }

    if (type === ERememberedAccountType.Email) {
      dispatch(changeToUsernameAuth(value));

      if (isEmail(value)) {
        dispatch(checkEmail());
      } else {
        dispatch(changeFlow(EActiveFlow.Authentication));
      }
    }

    trackSelectRememberedAccount(index);
  }, [dispatch]);
  var handleAccountDelete = React.useCallback(function (type, value, index) {
    var accounts = deleteRememberedAccount({
      type: type,
      value: value
    });
    setAccounts(accounts);
    trackDeleteRememberedAccount(index);

    if (accounts.length === 0) {
      switchFlow();
    }
  }, [switchFlow]);
  var handleEnterOtherAccount = React.useCallback(function () {
    switchFlow();
    trackEnterOtherAccount();
  }, [switchFlow]);
  var visibleAccounts = React.useMemo(function () {
    return accounts.slice(0, 3);
  }, [accounts]);
  return /*#__PURE__*/React.createElement(RememberedAccountsLayout, {
    title: /*#__PURE__*/React.createElement(TitleContainer, {
      indent: "M"
    }),
    subTitle: /*#__PURE__*/React.createElement(Paragraph2, null, "\u041D\u0435\u0434\u0430\u0432\u043D\u043E \u0432\u0445\u043E\u0434\u0438\u043B\u0438 \u0441 \u044D\u0442\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"),
    content: visibleAccounts.map(function (item, i) {
      return /*#__PURE__*/React.createElement(RememberedAccountItem, _extends({
        key: item.value,
        index: i
      }, item, {
        onClick: handleAccountClick,
        onDelete: handleAccountDelete
      }));
    }),
    controls: [/*#__PURE__*/React.createElement(Button, {
      "data-name": "AnotherAccountBtn",
      key: "exit",
      type: "button",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: handleEnterOtherAccount
    }, "\u0412\u043E\u0439\u0442\u0438 \u0432 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442")]
  });
};